<template>
  <div>
    <div class="member_collections">
      <div class="member_collections_title">收藏商品</div>

      <!-- <div class="member_collections_header">
        <p>商品收藏</p>
      </div> -->
      <div class="member_collections_administration">
        <div v-show="administration1Block" class="administration1 clearfix_">
          <span @click="administration1" class="fr">批量管理</span>
        </div>
        <div v-show="administration2Block" class="administration2 clearfix_">
          <div class="fr clearfix_">
            <p @click="allChecked" class="fl clearfix_"><i :class="{checkedActive:isAll}" class="checked_bg fl"></i><span class="fl">全选</span></p>
            <p @click="deleteCollections" class="fl clearfix_"><i class="collection_bg fl"></i><span class="fl">取消收藏</span></p>
            <p @click="administration2" class="fl">取消管理</p>
          </div>
        </div>
      </div>
      <div class="member_collections_goods GoodsListContentBox">
        <ul class="clearfix_">
          <li @click="choice(index,item.id)" v-for="(item,index) in collectionsList" :key="index" style="height:320px;" class="member_collections_item" :class="{member_collections_item_active:item.isChecked==true}">
            <div @click="gotoDetails(item.webName,item.goodsId,item.supplyChainTenantId)" class="goodslistpicbox">
              <img :title="item.goodsAlias?item.goodsAlias:item.goodsName" :src="item.pic1?item.pic1:timg" width="225" height="225"/>
              <div v-show="!item.isShow" class="invalid_collections_goods_txt">已失效</div>
            </div>
            <div class="goodslistprice clearfix_">
              <p class="fl">¥ {{item.price}}</p>
            </div>
            <div @click="gotoDetails(item.webName,item.goodsId,item.supplyChainTenantId)" class="goodslistnamebox">
              <p :title="item.goodsAlias?item.goodsAlias:item.goodsName">{{item.goodsAlias?item.goodsAlias:item.goodsName}}</p>
            </div>
            <div @click="deleteItemCollections(item.id)" class="member_collections_delete_goods">
              <span>取消收藏</span>
            </div>
            <div v-show="item.isChecked==true" class="member_collections_angle"><img :src="angle" alt=""></div>
          </li>
        </ul>
      </div>
      <div v-if="noData" style="text-align:center;margin-bottom:15px;">暂无任何收藏商品！</div>
      <div v-show="total" class="collections_goods_pages">
         <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="12"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
  </div>  
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  inject:['reload'],
  data(){
    return {
      administration1Block:true,
      administration2Block:false,
      currentPage3:1,
      collectionsList:[],
      total:0,
      timg:require('../../assets/img/timg.gif'),
      angle:require('../../assets/img/angle.png'),
      arr:[],
      noData:false,
      isAll:false
    }
  },
  mounted:function(){
    var t_=this
    t_.getCollections(t_.currentPage3)
  },
  methods:{
    allChecked:function(){
      var t_=this
      if(t_.isAll){
        t_.isAll=false
        t_.collectionsList.forEach(function(item,index){
          item.isChecked=false
        },t_)
        t_.arr=[]
      }else{
        t_.isAll=true
        t_.arr=[]
        t_.collectionsList.forEach(function(item,index){
          item.isChecked=true
          t_.arr.push(item.id)
        },t_)
      }
    },
    choice:function(idx,id){
      var t_=this
      if(t_.administration1Block)return
      if(t_.collectionsList[idx].isChecked){
        t_.collectionsList[idx].isChecked=false
        t_.isAll=false
        t_.arr.forEach(function(item,index){
          if(item==id)t_.arr.splice(index,1)
        },t_)
      }else{
        t_.collectionsList[idx].isChecked=true
        t_.arr.push(id)
        if(t_.arr.length==t_.collectionsList.length){
          t_.isAll=true
        }
      }
    },
    deleteItemCollections:function(id){
      var t_=this
      t_.arr.push(id)
      t_.deleteCollections()
    },
    deleteCollections:function(){
      var t_=this
      if(t_.arr.length==0)return t_.$message({
        message:'请选择要删除的收藏商品',
        center:true,
        type:'warning'
      })
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:JSON.stringify(t_.arr)
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/deteleCollection`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.arr=[]
          t_.$message({
            message:'收藏商品删除成功',
            center:true,
            type:'success'
          })
          t_.reload()
        }
      })
    },
    gotoDetails:function(web,id,supplyChainTenantId){
      var t_=this
      if(t_.administration2Block)return
      var url='http://'+web+'/goodsdetails?goodsId='+id+'&supplyChainTenantId='+supplyChainTenantId+'&isSupplyChainGoods='+2
      window.open(url,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.currentPage3=val
      this.collectionsList=[]
      this.getCollections(val)
    },
    administration1:function(){
      var t_=this
      t_.administration1Block=false
      t_.administration2Block=true
    },
    administration2:function(){
      var t_=this
      t_.isAll=false
      t_.arr=[]
      t_.collectionsList.forEach(function(item,index){
        item.isChecked=false
      },t_)
      t_.administration1Block=true
      t_.administration2Block=false
    },
    getCollections:function(val){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:val,
        pagesize:12
      })
      axios.post(`${ip}formWorkInterface/listCollection`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.rows.rows.length==0)t_.noData=true
          res.data.rows.rows.forEach(function(item,idx) {
            t_.$set(item,'isChecked', false)
          }, t_);
          t_.collectionsList=res.data.rows.rows
          t_.total=res.data.rows.total
        }
      })
    }
  }
}
</script>

<style>
 .member_collections_title{
    height: 38px;
    line-height: 38px;
    font-size:16px;
    font-weight: 900;
    background: #fafafa;
    padding-left: 10px;
  }
  .member_collections{
    /* height: 88px; */
    border: 1px solid #ddd;
    background: #fff;
    margin-bottom: 18px;
    position: relative;
  }
  .member_collections_header{
    height: 48px;
    border-bottom: 1px solid #ddd;
  }
  .member_collections_header p{
    color:#dd2c3a;
    border-bottom: 1px solid #dd2c3a;
    width: 183px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
  }
  .member_collections_goods{
    background: #fff;
    padding: 10px;
    padding-bottom: 0;
  }
  .member_collections_goods > ul > li{
    width: 238px;
    height: 379px;
    border: 1px solid #ddd;
    background: #fff;
    margin: 0 16px 20px 0;
    position: relative;
  }
  .member_collections_goods > ul > li:nth-child(4n){
    margin-right: 0;
  }
  /* .member_collections_goods .collections_mask{
    width: 240px;
    height: 381px;
    background: rgba(0, 0, 0, .3);
    position: absolute;
    top:0;
    left:0;
    cursor: pointer;
  }
  .member_collections_goods .collections_maskActive{
    width: 240px;
    height: 381px;
    background: rgba(0, 0, 0, .6);
    position: absolute;
    top:0;
    left:0;
    cursor: pointer;
  }
  .collections_mask .checkMark{
    width: 44px;
    height: 44px;
    background: url(../../assets/img/checkMark1.png);
    position: absolute;
    top:0;
    right:0;
  }
  .collections_maskActive .checkMarkActive{
    width: 44px;
    height: 44px;
    background: url(../../assets/img/checkMark2.png);
    position: absolute;
    top:0;
    right:0;
  } */
  .member_collections_goods img{
    width: 225px;
    height: 225px;
  }
  .member_collections_goods .pic{
    width: 225px;
    height: 225px;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .collections_goods{
    height: 92px;
    padding: 0 10px;
  }
  .collections_goods .name{
    color:#dd2a3c;
    line-height: 18px;
    margin-bottom: 7px;
    cursor: pointer;
  }
  .collections_goods .price{
    color:#dd2a3c;
  }
  .collections_btn{
    height: 32px;
    border-top: 1px solid #ddd;
    cursor: pointer;
  }
  .collections_btn .btn1{
    width: 119px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-right: 1px solid #ddd;
  }
  .collections_btn .btn2{
    width: 118px;
    height: 32px;
    line-height: 32px;
    text-align: center;
  }
  .member_collections_administration{
    position: absolute;
    top:0;
    right:0;
  }
  .member_collections_administration .administration2 p{
    line-height: 40px;
    margin-right: 30px;
    cursor: pointer;
  }
  .member_collections_administration .administration1 span,.member_collections_administration .administration2 p:last-child{
    width: 67px;
    height: 24px;
    border: 1px solid #bbb;
    text-align: center;
    line-height: 24px;
    margin-right: 20px;
    margin-top: 6px;
    cursor: pointer;
  }
  .member_collections_administration .administration2 i{
    width: 14px;
    height: 14px;
    margin-right: 4px;
    margin-top: 14px;
  }
  .member_collections_administration .administration2 .checked_bg{
    background: url(../../assets/img/checked_1.png);
    background-size: 100%;
  }
  .member_collections_administration .administration2 .collection_bg{
    background: url(../../assets/img/administration2.png) no-repeat 0 0;
    background-size: 100%;
  }
  .member_collections_administration .administration2 p:hover{
    color:#dd2a3c;
  }
  /* .member_collections_administration .administration2 p:first-child:hover .checked_bg{
    background: url(../../assets/img/checked_2.png);
  } */
  .member_collections_administration .administration2 .checkedActive{
    background: url(../../assets/img/checked_3.png);
    background-size: 100%;
  }
  .member_collections_administration .administration2 p:nth-child(2):hover .collection_bg{
    background: url(../../assets/img/administration1.png) no-repeat 0 0;
    background-size: 100%;
  }
  .collections_goods_pages{
    text-align: center;
    margin-bottom: 15px;
  }
  .collections_goods_pages .el-pagination__jump{
    margin-top:-9px;
  }
  .collections_goods_pages .el-pagination__editor{
    top:9px;
  }
  .goodslistpicbox{
    height: 225px;
    position: relative;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #dd2a3c;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    cursor: pointer;
  }
  .goodslistnamebox p:hover{
    color: #dd2a3c;
    text-decoration: underline;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 50%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #dd2a3c;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    /*display: none;*/
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#dd2a3c;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .member_collections_delete_goods{
    position: absolute;
    top: 193px;
    left: 0;
    width: 100%;
    height: 32px;
    padding: 5px 0;
    text-align: center;
    z-index: 2;
    background-color: rgba(255,255,255,.8);
    -webkit-transition: bottom .1s ease-in-out;
    transition: bottom .1s ease-in-out;
    display: none;
  }
  .member_collections_delete_goods span{
    display: inline-block;
    border-radius: 3px;
    text-decoration: none;
    text-align: center;
    vertical-align: top;
    -webkit-transition: .3s;
    transition: .3s;
    cursor: pointer;
    min-width: 60px;
    padding: 0 19px;
    height: 30px;
    border: 1px solid #ffbee0;
    width: 76px;
    background-color: transparent;
    border-color: #e2231a;
    color: #dd2a3c;
    font-size: 13px;
    line-height: 32px;
  }
  .member_collections_goods .member_collections_item:hover .member_collections_delete_goods{
    display: block;
  }
  .GoodsListContentBox ul .member_collections_item{
    width: 224px;
    height: 352px;
    padding: 10px;
    float: left;
    border: 1px solid white;
    margin-right: 8px;
    margin-bottom: 20px;
    position: relative;
  }
  .GoodsListContentBox ul .member_collections_item:hover{
    border: 1px solid #dd2a3c;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .GoodsListContentBox ul .member_collections_item:nth-child(4n){
    margin-right: 0;
  }
  .GoodsListContentBox ul .member_collections_item_active{
    border:1px solid #dd2a3c;
  }
  .member_collections_angle{
    width: 40px;
    height: 40px;
    position: absolute;
    right:0;
    bottom:0;
  }
  .member_collections_angle img{
    width: 40px;
    height: 40px;
  }
  .invalid_collections_goods_txt{
    position: absolute;
    top:50%;
    left:50%;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color:#fff;
    background:rgba(0, 0, 0, .3);
    border-radius: 580%;
    margin-top: -40px;
    margin-left: -40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/collections.vue